<template>
    <div class="source-pop" v-show="showDialog" >
       <p class="source-pop-title">
        <span :class="className">{{type}}</span>
        {{ title }}{{ getXuhao(item) }}
      </p>
      <div v-loading="isLoading" class="source-pop-text">
        <!-- <div class="source-pop-text-inner"> -->
         <DTextmore @changeOpen="changeOpen" :key="id"  :data="text" :height="height"></DTextmore>
        <!-- </div> -->
      </div>
       <!-- 法规库 -->
       <p class="source-pop-bottom" v-if="className == 'fagui'">
            <!-- <svg-icon  v-show="item.metadata.jiguan" icon-class="city-one"></svg-icon>{{item.metadata.jiguan}}<span v-show="item.metadata.jiguan"></span> -->
            <svg-icon  v-show="item.metadata.shishi_date" icon-class="time"></svg-icon>{{item.metadata.fabu_date}}
        </p>
        <!-- 论文库 -->
        <p class="source-pop-bottom" v-if="className == 'lunwen'">
            <svg-icon  v-show="item.metadata.author" icon-class="user2"></svg-icon>{{item.metadata.author}}
            <span v-show="item.metadata.author"></span>
            <svg-icon  v-show="item.metadata.nian" icon-class="time"></svg-icon>{{item.metadata.nian}}
        </p>
        <!-- 案例库 -->
        <p class="source-pop-bottom" v-if="className == 'anli'">
            <svg-icon  v-show="item.metadata.fayuan" icon-class="city-one"></svg-icon>{{item.metadata.fayuan}}
            <span v-show="item.metadata.fayuan"></span>
            <svg-icon  v-show="item.metadata.nian" icon-class="time"></svg-icon>{{item.metadata.nian}}
        </p>
    </div>
</template>

<script>
import { geTraceData } from "@/api/ai.js";
import "@/views/components/DTextmore";
export default {
    data() {
       return {
            id: 0,
            item: null,
            text :'',
            className: '',
            title: '',
            type: '',
            sourceList: [],
            index: null,
            isLoading: false,
            type: '',
            height: 96,
            isQuate: false,
            isFloat: false,
            target: null,
       } 
    },
    computed: {
        showDialog() {
            if (!this.isQuate && !this.isFloat) {
                this.$parent.curTraceItem = null
                // 设置一个延时
                setTimeout(() => {
                    if(!this.isQuate && !this.isFloat) {
                        this.$parent.$el.style = ''
                    }
                }, 1000);
            }
            return this.isQuate || this.isFloat
        }
    },
    mounted() {
        let _this = this
        this.$nextTick(() => {
            _this.$el.addEventListener('mouseover', function () {
                _this.isFloat = true
            }, false)
            _this.$el.addEventListener('mouseout', function () {
                _this.isFloat = false
            }, false)
        })
        document.addEventListener('scroll', this.handleScroll, false)
    },
    unmounted() {
        document.removeEventListener('scroll', this.handleScroll, false)
    },
    methods: {
        getXuhao(item) {
            if (item && item.metadata.item_xuhao && item.metadata.item_xuhao != 'undefined') {
                return '  ' + item.metadata.item_xuhao
            } 
            return ''
        },
        changeOpen(val) {
            if (val) {
                this.handleScroll()
            }
        },
        handleScroll() {
            if (this.showDialog) {
               this.computeConHeight()
            }
        },
        computeConHeight() {
            const target = this.target
            const parentNode = this.findParentNode(target, 'content')
            const { top: top1, left: left1} = this.getElementPositionByDocument(target)
            const { top, left} = this.getElementPositionByWindow(target)
            this.$el.style.top = top + 20 + 'px'
            this.$el.style.left = left - 240 + 'px'
            // 监听，如果滚动到底部依然无法全部显示，则需要认为拉长文档高度，需要在弹框消失后人为恢复
            const [ isBottom, documentHeight, scrollTop] = this.isScrollAtBottom()
            if (isBottom) {
                let h = top1 + this.$el.offsetHeight - documentHeight
                if (h > 0) {
                    const to = this.$parent.$el.offsetHeight + h
                    // 设置问答容器高度
                    this.$parent.$el.style = `height: ${to}px`
                } 
            }
        },
        handleActivate(e) {
            const { target } = e
            this.isLoading = false
            this.id++
            this.isQuate = true
            this.target = target
            this.title = target.getAttribute('title')
            const parentNode = this.findParentNode(target, 'content')
            const index = Number(/\[(.*?)\]/g.exec(target.innerText)[1])
            let question = ''
            const traceButton = parentNode.querySelector('.btm-box .traceBUtton')
            const { top, left} = this.getElementPositionByWindow(target)
            this.$el.style.top = top + 20 + 'px'
            this.$el.style.left = left - 240 + 'px'
            traceButton && (question = traceButton.getAttribute('data-question'))
             
            // 判断是不是当前溯源
           if (traceButton && traceButton.classList.contains('curTrace') ){
             this.sourceList = this.$parent.traceList
             this.getInfo(index - 1)
           } else {
            this.item = null
            this.text = ''
            this.className = ''
            this.type = ''
            this.isLoading  = true
            const data = {
                question,
                "filter": Object.keys(this.$parent.mapDatabase)
            }
            geTraceData(data).then(async res => {
                if(res.count == 0) {
                    this.sourceList = res.refs
                    this.getInfo(index)
                }
                this.isLoading = false
            }).catch(err => {
                this.isLoading = false
            })
           }
        },
        close() {
            this.isQuate = false
        },
        getInfo(index) {
            this.item = this.sourceList[index]
            this.title = this.item.metadata.title || this.item.metadata.zheng_biaoti
            this.className = this.$parent.mapDatabase[this.item.metadata.show_type].className
            this.type = this.$parent.mapDatabase[this.item.metadata.show_type].title
            this.text = this.item.metadata.text
            this.$parent.curTraceItem = (this.item.metadata.file_id || this.item.metadata.bianhao)
        },
        // 获取父节点
        findParentNode(node, str) {
            let childNode = node
            let parentNode = null
            while (childNode.parentNode) {
                if (childNode.parentNode.classList.contains(str)) {
                    // 找到了匹配的父节点
                    parentNode = childNode.parentNode;
                    break;
                }
                childNode = childNode.parentNode;
            }
            return parentNode
        },
        // 获取元素的位置
        getElementPositionByDocument(element) {
            var top = 0, left = 0;
            while (element) {
                top += element.offsetTop;
                left += element.offsetLeft;
                element = element.offsetParent;
            }
            return { top: top, left: left };
        },
        getElementPositionByWindow(element) {
            var rect = element.getBoundingClientRect();
            return { top: rect.top, left: rect.left };
        },
        // 是否滚动到底部
        isScrollAtBottom() {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            const documentHeight = document.documentElement.scrollHeight;
            return [scrollTop + windowHeight >= documentHeight, documentHeight, scrollTop];
        }
    }
}
</script>

<style lang="scss">
// 弹窗样式
@import "~@/assets/styles/common.mixin.scss";
.source-pop{
    position: fixed;
    width: 480px;
    z-index: 200;
    min-height: 100px;
    background: #fff;
    padding: 24px;
    transition: all 0.6s;
    // animation-delay: 0.2s;
    border-radius: 16px 16px 16px 16px;
    box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);
    &-title{
        width: 432px;
        font-weight: bold;
        font-size: 18px;
        color: #262626;
        line-height: 26px;
        text-align: left;
        span{
            margin-right: 2px;
            margin-top: 2px;
        }
        @include traceTag;
    }
    &-text{
        padding: 12px 12px 12px 16px;
        background: #F7F9FA;
        border-radius: 0px 8px 8px 0px;
        border-left: 4px #D7D7D7;
        font-size: 16px;
        color: #585A5A;
        line-height: 24px;
        margin-top: 12px;
        margin-bottom: 16px;
        .text-open{
            background: #F7F9FA;
            line-height: 24px;
            bottom: 2px;
        }
    }
    &-bottom{
        font-size: 14px;
        color: #8A8F8D;
        span{
            padding-left: 16px;
        }
        svg{
            margin-right :4px;
        }
    }
}
</style>